import React, {Component} from "react";  import config from 'react-global-configuration';
import msparcs from "assets/img/msparcs.png";
import TableauReport from 'tableau-react';
import axios from "axios";
class TableauReports extends Component {
    state = {
        data: [],
        chartHeight:"250px",
        tableau_token:""
    };
    componentWillMount(){

    }
     componentDidMount() {
       //this._get_tableau_token();
       alert(localStorage.tableau_user_token)
     }


  
    render() {
        let url = "http://tableauuat.innoviti.blr/trusted/zh7lsj9VQt2TiAD_OcZIbw==:WPUbw6ThyZHbyS10iw6rTwst/views/NTCR/NTCR?:showAppBanner=true&:display_count=n&:showVizHome=n&:origin=viz_share_link";
        //console.log("uuuu", url)
        return (
            <div className = "content">
                <div className="container-fluid space-container-fluid">
                    <div className = "row">
                        <div className="col-md-12">
                            <div className="card p-10">
                                <div className="header text-center">
                                   <h4 className="title">
                                        Test
                                    </h4>
                                <div>

                                <iframe src={url} width="950" height="955"></iframe>
                                {/*                                     <TableauReport url="http://public.tableau.com/views/RegionalSampleWorkbook/Storms" */}

                                {/*                                       /> */}
{/*                                 <TableauReport url="http://tableauuat.innoviti.blr/views/NTCR/NTCR?:showAppBanner=false&:display_count=n&:showVizHome=n&:origin=viz_share_link" */}
{/*                                                                     token="vF7Xb4Z6R-aeFoPrRANCyQ==:dchWhJ3gxlrywJ9d1NlkUGt-" */}
{/*                                       /> */}
                                    </div>
                                </div>


                            </div>
                        </div>

                    </div>
                </div>
            </div>

        );

    }


}
export default TableauReports;